module.exports = __webpack_public_path__ + "static/ensemada-b204d4e1648da70fb14d9592d3efbcf5.jpg";